import { ApiUtil as api } from "@/utils/api.util.js";

export class VettedStatementService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/vetted-order-activities/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }

  static create(queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }

  static update(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }

  static delete(id) {
    return api.delete(this.URL + this.RESOURCE + id).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }

  static configure(id, queryParams = {}) {
    return api
      .post(this.URL + this.RESOURCE + id + "/configure", queryParams)
      .then(
        data => {
          return data;
        },
        error => {
          throw error;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/services/vettedStatement.service.js